import React, { Context, createContext, FC, ReactElement, ReactNode, useState } from 'react'
import { ReactState, StateSetter } from '../Types/Types'

export type ViewOnlyContextType = {
    isViewOnly: boolean
    setIsViewOnly: StateSetter<boolean>
}

type Props = {
    initialValue?: boolean
    children: ReactNode
}

export const ViewOnlyContextProvider: FC<Props> = ({ initialValue, children }): ReactElement => {
    const [isViewOnly, setIsViewOnly]: ReactState<boolean> = useState<boolean>(initialValue ?? false)

    return <ViewOnlyContext.Provider value={{ isViewOnly, setIsViewOnly }}>{children}</ViewOnlyContext.Provider>
}

const ViewOnlyContext: Context<ViewOnlyContextType> = createContext<ViewOnlyContextType>({
    isViewOnly: false,
    setIsViewOnly: () => {
        // eslint-disable-next-line
        console.debug('ViewOnlyContext: setIsViewOnly: Not implemented.')
    }
})
export default ViewOnlyContext
